var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","dark":"","medium":"","color":"secondary"},on:{"click":_vm.handleDownload}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-file-excel-outline")]),_vm._v(" Exportar ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }